import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { ProductResponse } from 'src/app/models/product.model';
import { ProductRecipe } from 'src/app/models/recipe-response';
import { ResponseObject } from 'src/app/models/response-object.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { ProductService } from 'src/app/services/product.service';
import { RecipeService } from 'src/app/services/recipe.service';

@Component({
  selector: 'app-edit-recipe',
  templateUrl: './edit-recipe.component.html',
  styleUrls: ['./edit-recipe.component.scss']
})
export class EditRecipeComponent {
  @Input() ingredients: Array<ProductRecipe> = [];
  @Input() recipeId: number;
  @Output() saveDataEvent = new EventEmitter<ProductRecipe>();
  @Output() addDataEvent = new EventEmitter<ProductRecipe>();
  @Output() deleteDataEvent = new EventEmitter<[recipeId: number, ingredientId: number]>();
  editingIngredient: number | null = null;
  addingIngredient: number | null = null;
  loading: { [key: number]: boolean } = {};
  loadingInput: { [key: number]: boolean } = {};
  productCosts: { [key: number]: number } = {};

  inputs = {};
  timeout = null;
  prescribe = false;
  products = [];
  listProducts = [];
  toProducts = [];

  allProducts = [];
  filteredProducts = [];
  selectedProduct?: ProductResponse;
  productInput = {
    value: '',
    data: null,
    verified: true,
    required: true,
    class: '',
    bgColor: ''
  };


  constructor(
    private productService: ProductService,
    private inventoryService: InventoryService,
    private recipeService: RecipeService,
    private toastService: ToastrService,
  ) {}

  ngOnInit() {
    this.startData();
  }

  startData(){
    this.getProducts();
    this.culculateCost();
  }

  addIngredient(){
    if (this.addingIngredient === this.recipeId) {
      this.addingIngredient = null;
    } else {
      this.addingIngredient = this.recipeId;
    }
  }

  startEditing(ingredientId: number) {
    this.editingIngredient = ingredientId;
  }
  
  endEditing() {
    this.editingIngredient = null;
  }

  saveQuantity(ingredient: ProductRecipe, newQuantity: string) {
    if (!newQuantity || isNaN(Number(newQuantity))) {
      return;
    }
    this.recipeService.updateRecipe(ingredient.id, Number(newQuantity)).subscribe({
      next: (response: any) => {
        ingredient = response.data;
        this.ingredients.forEach(element => {
          if (element.id === ingredient.id) {
            element.quantity = ingredient.quantity;
          }
        });
        this.startData();
        this.sendDataSave(ingredient);
        this.toastService.success("Cantidad actualizada correctamente", "Éxito");
      },
      error: (error) => {
        this.toastService.error("Error al actualizar la cantidad", "Error");
      }
    });

    this.editingIngredient = null;
  }

  deleteIngredient(ingredient: ProductRecipe) {
    this.recipeService.deleteRecipeById(ingredient.id).subscribe({
      next: (response: any) => {
        this.ingredients = this.ingredients.filter(i => i.id !== ingredient.id);
        this.sendDataDelete(ingredient.productidcreated, ingredient.id);
        this.toastService.success("Ingrediente eliminado correctamente", "Éxito");
      },
      error: (error) => {
        this.toastService.error("Error al eliminar el ingrediente", "Error");
      }
    });
  }

  sendDataSave(productRecipe: ProductRecipe) {
    this.saveDataEvent.emit(productRecipe);
  }

  sendDataDelete(recipeId: number, ingredientId: number) {
    this.deleteDataEvent.emit([recipeId, ingredientId]);
  }

  sendDataAdd(productRecipe: ProductRecipe) {
    this.addDataEvent.emit(productRecipe);
  }

  selectProduct(product: any, input: any, isResult: boolean) {
      clearTimeout(this.timeout);
      //input.value = product.title;
      input.verified = false;
      input.data = null;
      if (!isResult) {
        input.class = "loading";
        this.productService.getExistence(this.inputs['toTransfer'].data.id, product.id).subscribe(
          {
            next: (response: ResponseObject) => {
              input.class = "fa-list";
              if (response.data > 0 || this.prescribe) {
                this.listProducts.push({ product: product, id: product.id, name: product.name, quantity: 1, existence: response.data, costPercentage: 0 })
              } else {
                this.toastService.info("El producto " + product.name + " no cuenta con existencias en la bodega");
              }
            },
            error: (error: HttpErrorResponse) => {
              input.class = "fa-xmark";
              this.toastService.error(error.error.success);
            }
          }
        )
      } else {
        this.toProducts.push({ product: product, id: product.id, name: product.name, quantity: 1, existence: null, costPercentage: 0 })
      }
    }

  writeProduct(inputValue: string, input: any, isResult: boolean) {
    input.class = "typing";
    input.filterElements = this.products.filter((w: ProductResponse) => {
      var lowcase = inputValue ? inputValue.toLowerCase() : "";
      return w.id+"" == inputValue || w.name.toLowerCase().includes(lowcase) || w.code.toLowerCase().includes(lowcase)
        || w.barCode?.toLowerCase().includes(lowcase);
    });
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      if (input.filterElements.length == 1) {
        this.selectProduct(input.filterElements[0], input, isResult);
      } else {
        input.class = (input.filterElements.length == 0) ? "fa fa-xmark" : "fa fa-list";
        input.verified = false;
        input.data = null;
      }
    }, 1000);
  }

  getProducts() {
    this.productService.getProducts('').subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data;
        this.products = this.products.filter((p) => {
          return p.type != "s"
        })
        this.allProducts = this.products;
        this.filteredProducts = [...this.products];
        // this.inputs['product'] = { value: null, verified: false, required: false, class: 'fa-list', data: null, filterElements: this.products, bgColor: "" };
        // this.inputs['toTransfer'] = { value: null, verified: false, required: false, class: 'fa-list', data: null, filterElements: this.products, bgColor: "" };
        // this.inputs['result'] = { value: null, verified: false, required: false, class: 'fa-list', data: null, filterElements: this.products, bgColor: "" };
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.success);
      }
    })
  }

  // 🔹 Se ejecuta cuando escribe en el input
  onInput(event: any) {
    const value = event.event.target.value.toLowerCase();
    this.filteredProducts = this.allProducts.filter(p =>
      p.name.toLowerCase().includes(value)
    );
  }

  // 🔹 Cuando selecciona un producto
  onSelectProduct(event: any) {
    this.selectedProduct = event.filterElement;
    this.recipeService.addRecipe(this.recipeId, this.selectedProduct.id, 0).subscribe({
      next: (response: any) => {
        const newIngredient: ProductRecipe = response.data;
        this.sendDataAdd(newIngredient);
        this.toastService.success("Ingrediente agregado correctamente", "Éxito");
        this.startData();
      }
      ,
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al agregar el ingrediente", "Error");
      }
    });
    this.productInput = {
      value: '',
      data: null,
      verified: false,
      required: true,
      class: '',
      bgColor: ''
    };
    this.selectedProduct = null;
    this.filteredProducts = [...this.allProducts];
  }

  culculateCost() {
    this.ingredients.forEach(ingredient => {
      this.inventoryService.getLastProduct(ingredient.productidingredient).subscribe({
        next: (response: ResponseObject) => {
          if (response.data === null) {
            this.productCosts[ingredient.id] = 0;
            return;
          }
          const cost = response.data.cost as number;
          this.productCosts[ingredient.id] = cost;
        },
        error: (error: HttpErrorResponse) => {
          this.toastService.error(`Error al obtener el costo del producto: ${ingredient.productDataIngredient.name}`, "Error");
        }
      });
    });
  }

  get totalcost() {
    let total = 0;
    this.ingredients.forEach(ingredient => {
      const cost = this.productCosts[ingredient.id] || 0;
      total += cost * ingredient.quantity;
    });
    return total.toFixed(2);
  }

  getIngredientTotalCost(ingredient: ProductRecipe): number {
    return (this.productCosts[ingredient.id] || 0) * ingredient.quantity;
  }

}
